var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.53 17.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "android") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44,3.63H8.72V2.91h.72Zm-3.63,0H5.09V2.91h.72Zm4-2.06.95-.95a.36.36,0,0,0,0-.51.37.37,0,0,0-.52,0h0L9.19,1.18a4.36,4.36,0,0,0-3.86,0L4.25.11a.35.35,0,0,0-.51,0,.36.36,0,0,0,0,.51l1,1A4.36,4.36,0,0,0,2.91,5.09h8.71A4.36,4.36,0,0,0,9.83,1.57Zm3.61,4.24A1.09,1.09,0,0,0,12.35,6.9V12a1.09,1.09,0,0,0,2.18,0V6.9a1.09,1.09,0,0,0-1.09-1.09Zm-12.35,0A1.09,1.09,0,0,0,0,6.9V12a1.09,1.09,0,0,0,2.18,0V6.9A1.09,1.09,0,0,0,1.09,5.81Zm1.82,7.26a.73.73,0,0,0,.72.73h.73v2.54a1.09,1.09,0,0,0,2.18,0V13.8H8v2.54a1.09,1.09,0,0,0,2.18,0V13.8h.73a.73.73,0,0,0,.72-.73V5.81H2.91Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.bdc3daf4c8de41f89cfca57723bb47a9.svg";
export { ForwardRef as ReactComponent };